"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderAxes = void 0;
var canvas_1 = require("../../../../../renderers/canvas");
var common_1 = require("../../../../../utils/common");
var spec_1 = require("../../../state/utils/spec");
var axis_type_utils_1 = require("../../../utils/axis_type_utils");
var axis_utils_1 = require("../../../utils/axis_utils");
var debug_1 = require("../utils/debug");
var global_title_1 = require("./global_title");
var line_1 = require("./line");
var panel_title_1 = require("./panel_title");
var tick_1 = require("./tick");
var tick_label_1 = require("./tick_label");
function renderAxes(ctx, props) {
    var axesSpecs = props.axesSpecs, perPanelAxisGeoms = props.perPanelAxisGeoms, axesStyles = props.axesStyles, sharedAxesStyle = props.sharedAxesStyle, debug = props.debug, renderingArea = props.renderingArea;
    var seenAxesTitleIds = new Set();
    perPanelAxisGeoms.forEach(function (_a) {
        var axesGeoms = _a.axesGeoms, panelAnchor = _a.panelAnchor;
        canvas_1.withContext(ctx, function (ctx) {
            axesGeoms.forEach(function (geometry) {
                var _a;
                var _b = geometry.axis, panelTitle = _b.panelTitle, id = _b.id, position = _b.position, secondary = _b.secondary, anchorPoint = geometry.anchorPoint, size = geometry.size, dimension = geometry.dimension, ticks = geometry.visibleTicks, parentSize = geometry.parentSize;
                var axisSpec = spec_1.getSpecsById(axesSpecs, id);
                if (!axisSpec || !dimension || !position || axisSpec.hide) {
                    return;
                }
                var axisStyle = (_a = axesStyles.get(axisSpec.id)) !== null && _a !== void 0 ? _a : sharedAxesStyle;
                if (!seenAxesTitleIds.has(id)) {
                    seenAxesTitleIds.add(id);
                    global_title_1.renderTitle(ctx, __assign(__assign({}, props), { panelTitle: panelTitle, size: parentSize, anchorPoint: anchorPoint,
                        dimension: dimension,
                        axisStyle: axisStyle,
                        axisSpec: axisSpec }));
                }
                renderAxis(ctx, {
                    panelTitle: panelTitle,
                    secondary: secondary,
                    panelAnchor: panelAnchor,
                    axisSpec: axisSpec,
                    anchorPoint: anchorPoint,
                    size: size,
                    dimension: dimension,
                    ticks: ticks,
                    axisStyle: axisStyle,
                    debug: debug,
                    renderingArea: renderingArea,
                });
            });
        });
    });
}
exports.renderAxes = renderAxes;
function renderAxis(ctx, props) {
    canvas_1.withContext(ctx, function (ctx) {
        var ticks = props.ticks, size = props.size, anchorPoint = props.anchorPoint, debug = props.debug, axisStyle = props.axisStyle, axisSpec = props.axisSpec, panelAnchor = props.panelAnchor, secondary = props.secondary;
        var showTicks = axis_utils_1.shouldShowTicks(axisStyle.tickLine, axisSpec.hide);
        var position = axisSpec.position;
        var isVertical = axis_type_utils_1.isVerticalAxis(position);
        var y = isVertical
            ? anchorPoint.y + panelAnchor.y
            : anchorPoint.y + (position === common_1.Position.Top ? 1 : -1) * panelAnchor.y;
        var x = isVertical
            ? anchorPoint.x + (position === common_1.Position.Right ? -1 : 1) * panelAnchor.x
            : anchorPoint.x + panelAnchor.x;
        var translate = {
            y: y,
            x: x,
        };
        ctx.translate(translate.x, translate.y);
        if (debug && !secondary) {
            debug_1.renderDebugRect(ctx, __assign({ x: 0, y: 0 }, size));
        }
        canvas_1.withContext(ctx, function (ctx) {
            line_1.renderLine(ctx, props);
        });
        if (secondary)
            return;
        if (showTicks) {
            canvas_1.withContext(ctx, function (ctx) {
                ticks.forEach(function (tick) {
                    tick_1.renderTick(ctx, tick, props);
                });
            });
        }
        if (axisStyle.tickLabel.visible) {
            canvas_1.withContext(ctx, function (ctx) {
                ticks
                    .filter(function (tick) { return tick.label !== null; })
                    .forEach(function (tick) {
                    tick_label_1.renderTickLabel(ctx, tick, showTicks, props);
                });
            });
        }
        canvas_1.withContext(ctx, function (ctx) {
            panel_title_1.renderPanelTitle(ctx, props);
        });
    });
}
//# sourceMappingURL=index.js.map